Controller.$inject = [];

function Controller() {

}

export function HuiBadge() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            shape: '@',
            sizing: '@',
            variant: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<span class="hui hui-badge"
                              ng-class="['hui-' + ($huiCtrl.color || 'accent'),  
                                        $huiCtrl.shape || 'rounded',
                                        $huiCtrl.sizing || 'sm',
                                        $huiCtrl.variant || 'solid']"
                              ng-transclude></span>`;
        }
    }
}